import { Mixins, Component } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import pageMixin from '../../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  public mList: Array<any> = [];

  public column: Array<ITABLECOLCONF> = [];

  private loading: boolean = false;
}
